export default "__VITE_ASSET__BSNVmWfK__"